@if (screenInfo$ | async; as screen) {
  <div style=" display: flex; flex-direction: column; height: 100%">
    @if (isLoading) {
      <div
        style="flex: 1 0 100%; min-height: 0; display: flex; flex-direction: column; justify-content: space-between;">
        @if (selectedWidget === 'instrument' || selectedWidget === 'service-history') {
          <sh-tabs id="activities-tabs-1" style="width: 60%" condensed [collapsed]="screen.size === 'XSmall' || screen.size === 'Small' || screen.size === 'Medium'"
            >
            @for (tab of displayedTabs; track tab.name) {
              <sh-tab-item id="activities-tab-item-2" disabled [active]="activeTab === tab.name"
              (click)="switchTab(tab.name)" [attr.label]="tab.labelKey | transloco"></sh-tab-item>
            }
          </sh-tabs>
        }
        <div style="flex: 1; display: flex; align-items: center; justify-content: center;">
          <sh-spinner id="activities-spinner-3" site="s"></sh-spinner>
        </div>
      </div>
    }
    @if (!isLoading && visits) {
      <div style="flex: 1; min-height: 0;">
        <p-table [size]="'small'" #table [value]="visits" [scrollable]="true" scrollHeight="flex"
          [customSort]="true" (sortFunction)="customSort($event)" [sortField]="'start'" [sortOrder]="1">
          <!-- Tools -->
          <ng-template #caption style="border: none;">
            <div style="display: flex; align-items: center; gap: 8px;">
              @if (selectedWidget === 'instrument' || selectedWidget === 'service-history') {
                <sh-tabs id="activities-tabs-4" style="flex: 1 1 60%;" condensed [collapsed]="screen.size === 'XSmall' || screen.size === 'Small' || screen.size === 'Medium'"
                  >
                  @for (tab of displayedTabs; track tab.name) {
                    <sh-tab-item id="activities-tab-item-5" [active]="activeTab === tab.name"
                    (click)="switchTab(tab.name)" [attr.label]="tab.labelKey | transloco"></sh-tab-item>
                  }
                </sh-tabs>
              }
              <div class="table-tools" style="flex: 1 1 40%; gap: 8px; align-items: center;">
                <sh-dropdown id="activities-dropdown-6" no-border condensed style="min-width: 100px; max-width: 140px;" [attr.value]="(selectedRange === 30 ? 'msNotifications.range.last30Days' : selectedRange === 60 ? 'msNotifications.range.last60Days' : selectedRange === 90 ? 'msNotifications.range.last90Days' : selectedRange === 120 ? 'msNotifications.range.last120Days' : 'msNotifications.range.last120Days') | transloco">
                  <sh-menu-item id="activities-menu-item-last-30-days" (click)="changeRange(30,'serviceHistory')" [attr.label]="'msNotifications.range.last30Days' | transloco"
                  [active]="selectedRange === 30"></sh-menu-item>
                  <sh-menu-item id="activities-menu-item-last-60-days" (click)="changeRange(60,'serviceHistory')" [attr.label]="'msNotifications.range.last60Days' | transloco"
                  [active]="selectedRange === 60"></sh-menu-item>
                  <sh-menu-item id="activities-menu-item-last-90-days" (click)="changeRange(90,'serviceHistory')" [attr.label]="'msNotifications.range.last90Days' | transloco"
                  [active]="selectedRange === 90"></sh-menu-item>
                  <sh-menu-item id="activities-menu-item-last-120-days" (click)="changeRange(120,'serviceHistory')" [attr.label]="'msNotifications.range.last120Days' | transloco"
                  [active]="selectedRange === 120"></sh-menu-item>
               
                </sh-dropdown>
                <p-columnFilter style="flex: 0 1 210px;" type="text" [showMenu]="false" field="activity"
                  matchMode="contains">
                  <ng-template #filter let-value let-filter="filterCallback" style="width: 100%;">
                    <sh-search id="activities-search-search-for-activity" no-border [attr.label]="'activities.filter.searchForActivity' | transloco" condensed [(ngModel)]="searchTerm"
                    (ngModelChange)="filter($event)"></sh-search>
                  </ng-template>
                </p-columnFilter>
                <sh-divider id="activities-divider-12" spacing='s' style="height: 30px;" vertical></sh-divider>
                <sh-icon id="activities-icon-13" button icon='refresh' size="s" (click)="refresh()"></sh-icon>
                @if (workareaSize !== 'fullscreen') {
                  <sh-icon id="activities-icon-14" size="xs" [icon]="workareaSize === 'medium' ? 'arrow-face-up-l' : 'arrow-face-down-l'"
                  button (click)="onMaximize()" [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
                }
                <sh-icon id="activities-icon-expand" size="s" [icon]="workareaSize === 'fullscreen' ? 'split-vertically' : 'maximize'" button (click)="onExpand($event)"
                [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
                <sh-icon id="activities-icon-cancel" icon="cancel" size="s" button (click)="onMinimize()"
                [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
              </div>
            </div>
          </ng-template>
          <!-- Header -->
          <ng-template #header>
            <tr>
              <th pSortableColumn="activity" style="min-width:175px;" pFrozenColumn>
                <div style="display: flex; align-items: center; gap: 6px;">{{ 'activities.table.activity' | transloco }}<p-sortIcon
                field="activity" /></div>
              </th>
              @if (!isDeviceUI) {
                <th pSortableColumn="serial" style="min-width:150px;">
                  <div style="display: flex; align-items: center; gap: 6px;">{{ 'activities.table.serialNumber' | transloco }}<p-sortIcon
                  field="serial" /></div>
                </th>
              }
              <th pSortableColumn="type" style="min-width:125px;">
                <div style="display: flex; align-items: center; gap: 6px;">{{ 'activities.table.type' | transloco }}<p-sortIcon
                field="type" /></div>
              </th>
              <th pSortableColumn="start" style="min-width:125px;">
                <div style="display: flex; align-items: center; gap: 6px;">{{ 'activities.table.start' | transloco }}<p-sortIcon
                field="start" /></div>
              </th>
              <th pSortableColumn="end" style="min-width:125px;">
                <div style="display: flex; align-items: center; gap: 6px;">{{ 'activities.table.end' | transloco }}<p-sortIcon
                field="end" /></div>
              </th>
              <th pSortableColumn="travel" style="min-width:150px; text-align: right">
                <div style="display: flex; align-items: center; gap: 6px;">{{ 'activities.table.travelTime' | transloco }}<p-sortIcon
                field="travel" /></div>
              </th>
              @if (!businessPartnerMode) {
                <th pSortableColumn="labor" style="min-width:150px; text-align: right">
                  <div style="display: flex; align-items: center; gap: 6px;">{{ 'activities.table.laborTime' | transloco }}<p-sortIcon
                  field="labor" /></div>
                </th>
              }
              <th pSortableColumn="noti" style="min-width:125px;">
                <div style="display: flex; align-items: center; gap: 6px;">{{ 'activities.table.notification' | transloco }}<p-sortIcon
                field="noti" /></div>
              </th>
            </tr>
          </ng-template>
          <ng-template #body let-visit let-expanded="expanded">
            <tr>
              <td pFrozenColumn><span [innerHTML]="highlight(visit.activity)"></span></td>
              @if (!isDeviceUI) {
                <td>{{visit.serial_number}}</td>
              }
              <td>{{visit.type}}</td>
              <td>{{visit.start?.replace("T"," ")?.replace("Z","")}}</td>
              <td>{{visit.end?.replace("T"," ")?.replace("Z","")}}</td>
              <td style="text-align: right">
                @if (visit.travel_time > 0) {
                  <span>{{visit.travel_time.toFixed(2)}}</span>
                }
                @if (visit.travel_time === 0) {
                  <span>-</span>
                }
              </td>
              @if (!businessPartnerMode) {
                <td style="text-align: right">
                  @if (visit.labor_time > 0) {
                    <span>{{visit.labor_time.toFixed(2)}}</span>
                  }
                  @if (visit.labor_time === 0) {
                    <span>-</span>
                  }
                </td>
              }
              <td>
                <sh-text id="activities-text-16">{{visit.noti_id}}</sh-text>
              </td>
            </tr>
          </ng-template>
          <ng-template #footer>
            @if (isDeviceUI) {
              <tr>
                <td colspan="4" pFrozenColumn>{{ 'activities.footer.totals' | transloco }}</td>
                <td class="font-bold" style="text-align: right;">{{ retrieveTotalTravel() }}</td>
                @if (!businessPartnerMode) {
                  <td class="font-bold" style="text-align: right;">{{ retrieveTotalLabor() }}</td>
                }
                <td></td>
              </tr>
            }
            @if (!isDeviceUI) {
              <tr>
                <td colspan="5" pFrozenColumn>{{ 'activities.footer.totals' | transloco }}</td>
                <td class="font-bold" style="text-align: right;">{{ retrieveTotalTravel() }}</td>
                @if (!businessPartnerMode) {
                  <td class="font-bold" style="text-align: right;">{{ retrieveTotalLabor() }}</td>
                }
                <td></td>
              </tr>
            }
          </ng-template>
          <ng-template pTemplate="emptymessage">
            @if (isDeviceUI) {
              <tr>
                <td colspan="7">
                  @if (!isError) {
                    <div
                      style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
                      <sh-icon id="activities-icon-warning" icon="warning" size="s"></sh-icon>
                      <span>{{ 'common.empty.noData' | transloco }}</span>
                    </div>
                  }
                  @if (isError) {
                    <div
                      style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
                      <sh-icon id="activities-icon-error" icon="error" size="s"></sh-icon>
                      <span>{{ 'common.empty.error' | transloco }}</span>
                    </div>
                  }
                </td>
              </tr>
            }
            @if (!isDeviceUI) {
              <tr>
                <td colspan="8">
                  @if (!isError) {
                    <div
                      style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
                      <sh-icon id="activities-icon-warning" icon="warning" size="s"></sh-icon>
                      <span>{{ 'common.empty.noData' | transloco }}</span>
                    </div>
                  }
                  @if (isError) {
                    <div
                      style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
                      <sh-icon id="activities-icon-error" icon="error" size="s"></sh-icon>
                      <span>{{ 'common.empty.error' | transloco }}</span>
                    </div>
                  }
                </td>
              </tr>
            }
          </ng-template>
        </p-table>
      </div>
    }
  </div>
}